(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => [...r.querySelectorAll(s)];

  const isProductPage = () =>
    /^\/products(?:\/|$)/.test(location.pathname) ||
    document.body.classList.contains('template-product');

  const text = (el) => (el?.textContent || '').replace(/\s+/g,' ').trim();

  const visible = (el) => {
    if (!(el instanceof HTMLElement)) return false;
    const st = getComputedStyle(el);
    if (st.display === 'none' || st.visibility === 'hidden') return false;
    const r = el.getBoundingClientRect();
    return r.width > 8 && r.height > 8;
  };

  const findNativeAddButton = () => {
    const direct = [
      'button[name="add"]',
      '.product-form__submit',
      '[data-add-to-cart]',
      'button[type="submit"]'
    ];
    for (const sel of direct) {
      const matches = qsa(sel).filter(visible);
      const found = matches.find(el => /add to bag|add to cart/i.test(text(el))) || matches[0];
      if (found) return found;
    }
    return qsa('button').filter(visible).find(el => /add to bag|add to cart/i.test(text(el))) || null;
  };

  const findProductRoot = (addBtn) => {
    if (!addBtn) return null;
    let node = addBtn.parentElement;

    while (node && node !== document.body) {
      const hasTitle = !!qsa('h1,h2', node).find(h => /eyelash serum/i.test(text(h)));
      const hasPrice = /\$|USD|GBP|EUR|QAR|AED/.test(text(node));
      if (hasTitle && hasPrice) return node;
      node = node.parentElement;
    }

    return addBtn.closest('.product__info-container') ||
           addBtn.closest('.product__info-wrapper') ||
           addBtn.parentElement;
  };

  const findForm = (addBtn, root) =>
    addBtn?.closest('form') ||
    qs('form[action*="/cart/add"]', root) ||
    qs('form[action*="/cart/add"]');

  const findQtyInput = (form, root) =>
    qs('input[name="quantity"]', form || document) ||
    qs('input.quantity__input', root || document);

  const ensureQtyInput = (form, root) => {
    let input = findQtyInput(form, root);
    if (!input && form) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      input.value = '1';
      form.appendChild(input);
    }
    return input;
  };

  const findNativeQuantityBlock = (root) => {
    const labels = qsa('*', root).filter(visible).filter(el => text(el).toUpperCase() === 'QUANTITY');
    for (const label of labels) {
      let node = label.parentElement;
      for (let i = 0; i < 4 && node; i++, node = node.parentElement) {
        if (qs('.quantity, quantity-input, input[name="quantity"]', node)) return node;
      }
    }

    return qs('.product-form__quantity', root) ||
           qs('quantity-input', root)?.parentElement ||
           qs('.quantity', root)?.parentElement ||
           null;
  };

  const getPriceText = (root) => {
    const candidates = qsa('*', root)
      .filter(visible)
      .map(el => text(el))
      .filter(t => /(?:\$|USD|GBP|EUR|QAR|AED)\s*\d|\d[\d,.]*\s*(?:USD|GBP|EUR|QAR|AED)/i.test(t))
      .sort((a,b) => a.length - b.length);
    return candidates[0] || '$84.99 USD';
  };

  const parsePrice = (s) => {
    const m = (s || '').replace(/,/g,'').match(/(\d+(?:\.\d{1,2})?)/);
    return m ? Number(m[1]) : 84.99;
  };

  const detectCurrency = (s) => {
    const u = (s || '').toUpperCase();
    for (const c of ['USD','GBP','EUR','QAR','AED','CAD','AUD']) {
      if (u.includes(c)) return c;
    }
    if ((s || '').includes('£')) return 'GBP';
    if ((s || '').includes('€')) return 'EUR';
    return 'USD';
  };

  const money = (n, cur) => {
    try {
      return new Intl.NumberFormat(undefined,{
        style:'currency',
        currency:cur,
        maximumFractionDigits:2
      }).format(n);
    } catch {
      return `${n.toFixed(2)} ${cur}`;
    }
  };

  const buildOffer = (base, cur) => {
    const wrap = document.createElement('div');
    wrap.className = 'elizna-offer-v3';

    wrap.innerHTML = `
      <ul class="elizna-offer-v3__benefits">
        <li>Peptide-led lash care with conditioning and botanical support.</li>
        <li>Once-daily application designed for a consistent routine.</li>
        <li>Prostaglandin-free, paraben-free and vegan.</li>
        <li>4 mL / 0.14 fl oz per bottle.</li>
      </ul>

      <div class="elizna-offer-v3__notice">Choose the bottle count that best fits your routine.</div>

      <div class="elizna-offer-v3__section-title">Routine Selection</div>

      <div class="elizna-offer-v3__tiers">
        ${[1,2,3,4].map((qty, idx) => `
          <button class="elizna-offer-v3__tier ${qty===4?'is-selected':''}" type="button" data-qty="${qty}">
            <span class="elizna-offer-v3__radio"></span>
            <span>
              <span class="elizna-offer-v3__tier-title">${qty} ${qty===1?'Bottle':'Bottles'}</span>
              <span class="elizna-offer-v3__tier-price">${money(base*qty,cur)}</span>
            </span>
          </button>
        `).join('')}
      </div>

      <div class="elizna-offer-v3__extras-title">Included with every ELIZNA™ order</div>

      <div class="elizna-offer-v3__extras">
        <div class="elizna-offer-v3__extra"><span class="elizna-offer-v3__extra-icon">✦</span><span class="elizna-offer-v3__extra-text">Application guidance</span></div>
        <div class="elizna-offer-v3__extra"><span class="elizna-offer-v3__extra-icon">◇</span><span class="elizna-offer-v3__extra-text">Secure checkout</span></div>
        <div class="elizna-offer-v3__extra"><span class="elizna-offer-v3__extra-icon">↺</span><span class="elizna-offer-v3__extra-text">Delivery support</span></div>
        <div class="elizna-offer-v3__extra"><span class="elizna-offer-v3__extra-icon">✉</span><span class="elizna-offer-v3__extra-text">Client care</span></div>
      </div>

      <div class="elizna-offer-v3__care">
        <div class="elizna-offer-v3__care-icon">♡</div>
        <div>
          <strong>Client care, before and after purchase.</strong>
          <p>Questions about application, delivery or your routine? ELIZNA™ client care is available to help.</p>
        </div>
      </div>

      <button class="elizna-offer-v3__cta" type="button">Add Selected Quantity to Bag</button>
      <p class="elizna-offer-v3__fine">Selected quantity uses the live product price shown above.</p>
    `;

    return wrap;
  };

  const mount = () => {
    if (!isProductPage()) return true;
    if (qs('.elizna-offer-v3')) return true;

    const addBtn = findNativeAddButton();
    if (!addBtn) return false;

    const root = findProductRoot(addBtn);
    if (!root) return false;

    const form = findForm(addBtn, root);
    const qtyInput = ensureQtyInput(form, root);
    const qtyBlock = findNativeQuantityBlock(root);

    const priceText = getPriceText(root);
    const base = parsePrice(priceText);
    const cur = detectCurrency(priceText);

    const offer = buildOffer(base, cur);

    if (qtyBlock) {
      qtyBlock.before(offer);
    } else {
      const addContainer = addBtn.closest('.product-form__buttons') || addBtn;
      addContainer.before(offer);
    }

    // Hide the native quantity block and native Add to Bag button only after V3 exists.
    if (qtyBlock) qtyBlock.classList.add('elizna-offer-v3-native-hidden');
    addBtn.classList.add('elizna-offer-v3-native-hidden');

    let selectedQty = 4;
    const tiers = qsa('.elizna-offer-v3__tier', offer);

    tiers.forEach(btn => {
      btn.addEventListener('click', () => {
        tiers.forEach(x => x.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        selectedQty = Number(btn.dataset.qty || 1);
      });
    });

    qs('.elizna-offer-v3__cta', offer)?.addEventListener('click', async () => {
      if (qtyInput) {
        qtyInput.value = String(selectedQty);
        qtyInput.dispatchEvent(new Event('input',{bubbles:true}));
        qtyInput.dispatchEvent(new Event('change',{bubbles:true}));
      }

      if (form) {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(addBtn);
          return;
        }
        addBtn.click();
        return;
      }

      // Last-resort fallback if theme markup changes and no form ancestor is discoverable.
      addBtn.click();
    });

    return true;
  };

  let attempts = 0;
  const boot = () => {
    if (mount()) return;
    attempts += 1;
    if (attempts < 60) setTimeout(boot, 250);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', () => {
    attempts = 0;
    boot();
  }, { once:true });

  const observer = new MutationObserver(() => {
    if (!qs('.elizna-offer-v3')) {
      attempts = 0;
      boot();
    }
  });

  observer.observe(document.documentElement,{childList:true,subtree:true});
})();
